import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import Modal from "../../components/Modal";
import { Carousel } from "react-responsive-carousel";
import { getOnboardingCards } from "../../enums/onboarding";
import { useNavigate } from "react-router-dom";
import OTPSpendController from "../otp-spend/OTPSpendController";
import CheckInView from "../home/CheckInView";
import { useTranslation } from "react-i18next";
import { replaceParamTranslation } from "../../utils/util";
import crmservices from "../../wsclient";
import { cache } from "../../utils/cache";
import { config_path } from "../../router/config.path";

export default function OnboardingView(props) {
    const { palette } = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isOpen, setIsOpen, selectedItem, appConfig } = props;
    const [target, setTarget] = useState({});
    const [keepOpenModal, setKeepOpenModal] = useState(true);
    const session = crmservices.getSession() ;
    const orgName = session ? session.current_organisation_name : '';
    const isGuest = cache.getIsGuest();
    
    const [currentIndex, setCurrentIndex] = useState(0);
    const onBoardingSlides = getOnboardingCards(appConfig).filter(item => item.showInOnboarding);

    const handleNext = () => {
        if (currentIndex < onBoardingSlides.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handleSkipDone = async () => {
        try{
            let result = await crmservices.contacts.updateContactOnboardingCards({viewed: true})
            if (result && result.code === "OK") {
                var resultGetContact = await crmservices.contacts.getContact();
                if (resultGetContact.code === 'OK') {
                    let data = resultGetContact.data;
                    cache.setContact(data);
                }
            } else {
                console.error("Failed to update onboarding status", result);
            }
        }
        catch(e){
            console.error("Error updating onboarding status:", e);
        }

        setIsOpen(false);
    };


    const onClose = (event, reason) => {
        if(reason !== 'backdropClick') 
        {
            setIsOpen(false);
        }
    }

    const onClickNavigate = (item, event) => {
        if(isGuest){
            navigate(config_path.guest_info)
            return;
        }

        if (item.route) {
            if(item.id === 'PAYMENT_METHOD'){
                navigate(item.route, { state: { isOpenPaymentMethod: true} })
            }
            else if(item.id === 'ORDERS'){
                navigate(item.route, { state: { from: 'home_page' } })
            }
            else{
                navigate(item.route)
            }
        }
        else if(item.id === 'ONE_TAP'){
            if(props.onCloseOneTap) props.onCloseOneTap();
        }
        else{
            let target = item.id.toLowerCase();
            setTarget({
                [target]: true,
            })
            setKeepOpenModal(false)
        }
    }


    const carouselContent = () => {
        return(
            <Grid item xs={12} my={2} sx={{
                ".carousel .control-dots": {
                    position: 'absolute', 
                    bottom: '-15px'
                },
                ".control-dots .dot.selected": {
                    background: `${palette.primary.main} !important`,
                },
                ".carousel .slide img": {
                    width: '40%'
                }                
            }}>
                <Carousel autoPlay={false}
                    showArrows={false}
                    showThumbs={false}
                    showStatus={false}
                    emulateTouch={true}
                    interval={5000}
                    infiniteLoop={false}
                    selectedItem={currentIndex}
                    onChange={(index) => setCurrentIndex(index)}
                >
                    {onBoardingSlides.map((item, index) => {
                        return (
                            <Grid item xs={12} key={index} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mb:2}}>
                                <Box>
                                    <div>
                                        <lord-icon
                                            src={item.animationLink}
                                            trigger={"loop"}
                                            delay="1000"
                                            stroke="bold"
                                            colors={`primary:${palette.primary.main},secondary:${palette.secondary.main}`}
                                            style={{width:'80px',  height:'80px'}}
                                            >
                                        </lord-icon>
                                    </div>
                                    <Typography variant="h5">{replaceParamTranslation(t(item.title), [orgName])}</Typography>
                                    <Typography variant="subtitle1" color={palette.text.secondary} sx={{textAlign: 'center', mt: 1, mb:2}}>{replaceParamTranslation(t(item.description), [orgName])}</Typography>
                                </Box>
                            </Grid>
                        )
                                                
                    }
                    )}
                </Carousel>

                <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                    {currentIndex < onBoardingSlides.length - 1 ?
                        <Button onClick={handleSkipDone}>{t('skip')}</Button> :
                        <Box/>
                    }
                    {currentIndex === onBoardingSlides.length - 1 ? 
                        <Button onClick={handleSkipDone}>{t('btn_done')}</Button>:
                        <Button onClick={handleNext}>{t('btn_next')}</Button>
                    }
                </Box>

            </Grid>
        )

    }

   
    const singleSlideContent = () => {
        return(
            <Grid item xs={12} my={2} sx={{
                ".carousel .control-dots": {
                    position: 'absolute', 
                    bottom: '-15px'
                },
                ".control-dots .dot.selected": {
                    background: `${palette.primary.main} !important`,
                },
                ".carousel .slide img": {
                    width: '40%'
                }                
            }}>
                <Carousel autoPlay={false}
                    showArrows={false}
                    showThumbs={false}
                    showStatus={false}
                    emulateTouch={true}
                    interval={5000}
                    infiniteLoop={false}
                    showIndicators={false}
                    onChange={(index) => setCurrentIndex(index)}
                >
                    <Grid item xs={12} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mb:2}}>
                        <Box>
                            <div>
                                <lord-icon
                                    src={selectedItem.animationLink}
                                    trigger="loop"
                                    delay="1000"
                                    stroke="bold"
                                    colors={`primary:${palette.primary.main},secondary:${palette.secondary.main}`}
                                    style={{width:'80px',  height:'80px'}}
                                    >
                                </lord-icon>
                            </div>
                            <Typography variant="h5">{replaceParamTranslation(t(selectedItem.title), [orgName])}</Typography>
                            <Typography variant="subtitle1" color={palette.text.secondary} sx={{textAlign: 'center', mt: 1}}>{replaceParamTranslation(t(selectedItem.description), [orgName])}</Typography>
                        </Box>
                        <Button onClick={(event) => onClickNavigate(selectedItem, event)} sx={{ mt: 2 }}>{t(selectedItem.redirectText)}</Button>
                    </Grid>
                </Carousel>

            </Grid>
        )
    }
    

    return(
        <>
            <Modal isOpen={isOpen && keepOpenModal} onClose={onClose} centerOnMobile={true} enableCloseButton={selectedItem ? true : false} borderRadius='20px' backdrop={'rgba(0, 0, 0, 0.8)'}>
                {selectedItem ? singleSlideContent() : carouselContent()}
            </Modal>

            {target && target.spend && <OTPSpendController
                open={target.spend}
                onClose={() => {
                    setIsOpen(false)
                    setKeepOpenModal(true)
                    setTarget({})}
                }
            />}
            {target && target.identify && <CheckInView
                open={target.identify}
                onClose={() => {
                    setIsOpen(false)
                    setKeepOpenModal(true)
                    setTarget({})}
                }        
            />}
        </>

    )

    
}